'use strict';
var isPossiblePrototype = require('../internals/is-possible-prototype');

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError("Can't set " + $String(argument) + ' as a prototype');
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/a-possible-prototype.js
// module id = 491
// module chunks = 0